import { SignIn, SignUp } from "@clerk/react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";

const Panel = () => (
  <div className="relative hidden overflow-hidden bg-[#12343B] lg:flex lg:w-1/2 lg:flex-col lg:justify-between lg:p-12">
    <img src="/img/team_office.webp" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
    <Link to="/" className="relative"><Logo light size="text-3xl" /></Link>
    <div className="relative">
      <h2 className="text-4xl font-extrabold leading-tight text-white">Sua contabilidade inteligente, <span className="text-[#81D8D0]">simples e humana.</span></h2>
      <p className="mt-4 max-w-md text-white/70">Financeiro, documentos, obrigações e atendimento contábil em um só lugar.</p>
    </div>
    <p className="relative text-xs text-white/50">Imagem ilustrativa.</p>
  </div>
);

const Shell = ({ children }) => (
  <div className="flex min-h-screen bg-[#F4F6F8]">
    <Panel />
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-10">
      <Link to="/" className="lg:hidden"><Logo size="text-3xl" /></Link>
      {children}
    </div>
  </div>
);

export const SignInPage = () => <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/app" /></Shell>;
export const SignUpPage = () => <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/app" /></Shell>;
